export default "__VITE_ASSET__XDx$lHtg__"